// L'onglet du navigateur dit où en est l'agent : « Analyse en cours… » pendant
// un passage, « (3) » quand des leads attendent, et un point sur le favicon.
// Un passage dure plusieurs minutes et l'utilisateur part travailler ailleurs :
// c'est l'onglet qu'il regarde, pas la page.

import { t } from "./locale";

type TabStatus = { running: boolean; unread: number };

let pageTitle = "";
let status: TabStatus = { running: false, unread: 0 };
const originalIcons = new Map<HTMLLinkElement, string>();
let badgeRequest = 0;

function titleFor(title: string) {
  if (status.running) return t().common.tab.running(title);
  if (status.unread > 0) return `(${status.unread}) ${title}`;
  return title;
}

/** Le favicon de base avec un point dans le coin, dessiné sur un canvas. */
function paintFavicon(color: string | null) {
  const links = Array.from(document.querySelectorAll<HTMLLinkElement>("link[rel~='icon']"));
  for (const link of links) {
    if (!originalIcons.has(link)) originalIcons.set(link, link.href);
  }
  const request = ++badgeRequest;
  if (!color) {
    for (const [link, href] of originalIcons) link.href = href;
    return;
  }
  const image = new Image();
  image.onload = () => {
    if (request !== badgeRequest) return;
    const canvas = document.createElement("canvas");
    canvas.width = 64;
    canvas.height = 64;
    const context = canvas.getContext("2d");
    if (!context) return;
    context.drawImage(image, 0, 0, 64, 64);
    context.beginPath();
    context.arc(50, 14, 13, 0, Math.PI * 2);
    context.fillStyle = "#ffffff";
    context.fill();
    context.beginPath();
    context.arc(50, 14, 10, 0, Math.PI * 2);
    context.fillStyle = color;
    context.fill();
    const url = canvas.toDataURL("image/png");
    for (const link of originalIcons.keys()) link.href = url;
  };
  image.src = "/icon.png";
}

function render() {
  if (typeof document === "undefined") return;
  if (pageTitle) document.title = titleFor(pageTitle);
  // Ardoise pendant le passage, orange (--chart-2) quand des leads attendent.
  paintFavicon(status.running ? "#2a496f" : status.unread > 0 ? "#eb6834" : null);
}

export function setPageTitle(title: string) {
  pageTitle = title;
  render();
}

export function setTabStatus(next: Partial<TabStatus>) {
  const merged = { ...status, ...next };
  if (merged.running === status.running && merged.unread === status.unread) return;
  status = merged;
  render();
}
